<template>
  <div id="def1" ref="main" class="container" />
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "HRadar",
  props: {
    picCharts: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      chart: null, // 接收实例对象
    };
  },
  watch: {
    picCharts(newVal) {
      if (newVal !== "") {
        this.init();
      }
    },
  },
  mounted() {
    this.init();
  },

  methods: {
    init() {
      if (myChart != null && myChart !== "" && myChart !== undefined) {
        myChart.dispose(); // 销毁
      }
      var myChart = echarts.init(this.$refs.main);
      var a1 = [];
      var a2 = [];
      this.picCharts.forEach((e) => {
        a1.push(e.name);
        a2.push(e.value);
      });
      // 绘制图表
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: a1,
            axisLabel: {
              interval: 0,
              rotate: 20,
              color: "#999",
              textStyle: {
                fontSize: 10,
              },
            },
            axisTick: {
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "",
            type: "bar",
            barWidth: "60%",
            data: a2,
            itemStyle: {
            color: '#88baff'
          }
          },
        ],
      };

      myChart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 300px;
  // background: skyblue;
}
</style>
